'use client';

import { useEffect } from 'react';
import { useHistoryReset } from '@/hooks/useHistoryReset';

interface HistoryResetProviderProps {
  children: React.ReactNode;
  enabled?: boolean;
}

/**
 * Composant qui supprime automatiquement l'historique du chat
 * quand il est monté (typiquement sur la page d'accueil)
 */
export const HistoryResetProvider: React.FC<HistoryResetProviderProps> = ({ 
  children, 
  enabled = true 
}) => {
  const { resetHistory } = useHistoryReset({ enabled: false }); // On gère manuellement le timing

  useEffect(() => {
    if (enabled) {
      // Petit délai pour s'assurer que le composant est bien monté
      const timeoutId = setTimeout(() => {
        resetHistory();
      }, 100);

      return () => clearTimeout(timeoutId);
    }
  }, [enabled, resetHistory]);

  return <>{children}</>;
}; 